module.exports = __webpack_public_path__ + "img/O_action.8ac6630d.png";